"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_MILEAGE_DISTANCE_KM = void 0;
exports.MAX_MILEAGE_DISTANCE_KM = 10000;
